import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faLink,
  faKeyboard,
  faUserCog,
  faFilePrescription,
  faUserFriends,
  faLandmark,
  faExchangeAlt,
  faUserTie,
  faUser,
  faTachometerAlt,
  faFileAlt,
  faCreditCard,
  faSpaceShuttle,
  faSignal,
  faCog,
  faPlus,
  faComment,
  faMoneyBill,
  faBell,
  faHashtag,
  faSave,
  faFilter,
  faEdit,
  faTrash,
  faTrashAlt,
  faBackward,
  faShoppingBasket,
  faTimes,
  faUserPlus,
  faCartPlus,
  faArrowLeft,
  faArrowRight,
  faSpinner,
  faSignOutAlt,
  faCogs,
  faPencilAlt,
  faPrint,
  faCheck,
  faSync,
  faSortAmountDown,
  faSortAmountUp,
  faSearch,
  faAsterisk,
  faInfoCircle,
  faCheckCircle,
  faStar,
  faFile,
  faCloudUploadAlt,
  faDownload,
  faGripVertical,
  faCalendar,
  faFilePdf,
  faTimesCircle,
  faEnvelope,
  faEye,
  faShare,
  faEllipsisH,
  faCopy,
  faPaperPlane,
  faEyeSlash,
  faSyncAlt,
  faRocket,
  faCamera,
  faAddressCard,
  faAddressBook,
  faFileContract,
  faStickyNote,
  faShoppingBag,
  faUserTimes,
  faUserSecret,
  faArrowDown,
  faCaretDown,
  faMoneyCheck,
  faMoneyBillAlt,
  faInfo,
  faBuilding,
  faProcedures,
  faProjectDiagram,
  faChalkboardTeacher,
  faHandshake,
  faHistory,
  faPercentage,
  faMoneyBillWave,
  faFileExport,
  faShippingFast,
  faList,
  faListAlt,
  faPhone,
  faToggleOn,
  faToggleOff,
  faArrowsAltH,
  faTasks,
  faUsersCog,
  faUserTag,
  faRandom,
  faBan,
  faUnlock,
  faClone,
  faLocationArrow,
  faFileInvoice,
  faDatabase

} from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

window.Vue = require('vue')

library.add(
  faLink,
  faFileInvoice,
  faLocationArrow,
  faClone,
  faUnlock,
  faBan,
  faRandom,
  faUserTag,
  faUsersCog,
  faTasks,
  faArrowsAltH,
  faToggleOn,
  faToggleOff,
  faPhone,
  faList,
  faListAlt,
  faShippingFast,
  faFileExport,
  faMoneyBillWave,
  faPercentage,
  faHistory,
  faHandshake,
  faChalkboardTeacher,
  faProjectDiagram,
  faProcedures,
  faBuilding,
  faInfo,
  faMoneyBillAlt,
  faMoneyCheck,
  faCaretDown,
  faArrowDown,
  faUserSecret,
  faUserTimes,
  faShoppingBag,
  faFilePrescription,
  faStickyNote,
  faFileContract,
  faAddressCard,
  faAddressBook,
  far,
  faUserFriends,
  faUserCog,
  faLandmark,
  faExchangeAlt,
  faUserTie,
  faUser,
  faTrashAlt,
  faTachometerAlt,
  faFileAlt,
  faFile,
  faStar,
  faCreditCard,
  faSpaceShuttle,
  faSignal,
  faCog,
  faPlus,
  faMoneyBill,
  faComment,
  faBell,
  faHashtag,
  faSave,
  faFilter,
  faEdit,
  faTrash,
  faBackward,
  faShoppingBasket,
  faTimes,
  faTimesCircle,
  faUserPlus,
  faCartPlus,
  faArrowLeft,
  faArrowRight,
  faCartPlus,
  faSpinner,
  faSignOutAlt,
  faCogs,
  faPencilAlt,
  faPrint,
  faCheck,
  faSync,
  faSortAmountDown,
  faSortAmountUp,
  faSearch,
  faAsterisk,
  faInfoCircle,
  faCheckCircle,
  faPencilAlt,
  faCloudUploadAlt,
  faDownload,
  faGripVertical,
  faCalendar,
  faFilePdf,
  faEnvelope,
  faEye,
  faEyeSlash,
  faShare,
  faEllipsisH,
  faCopy,
  faPaperPlane,
  faSyncAlt,
  faRocket,
  faCamera,
  faKeyboard,
  faDatabase

)

Vue.component('font-awesome-icon', FontAwesomeIcon)
